const Import_constants = {
  GET_IMPORT_TYPE_SUCCESS: "GET_IMPORT_TYPE_SUCCESS",
  GET_IMPORT_TYPE_FAILURE: "GET_IMPORT_TYPE_FAILURE",

  GET_IMPORT_CONFIG_ON_ID_SUCCESS: "GET_IMPORT_CONFIG_ON_ID_SUCCESS",
  GET_IMPORT_CONFIG_ON_ID_FAILURE: "GET_IMPORT_CONFIG_ON_ID_FAILURE",

  GET_IMPORT_TEMPLATE_SUCCESS: "GET_IMPORT_TEMPLATE_SUCCESS",
  GET_IMPORT_TEMPLATE_FAILURE: "GET_IMPORT_TEMPLATE_FAILURE",

  UPLOAD_TEMPLATE_DATA_SUCCESS: "UPLOAD_TEMPLATE_DATA_SUCCESS",
  UPLOAD_TEMPLATE_DATA_FAILURE: "UPLOAD_TEMPLATE_DATA_FAILURE",
};
export default Import_constants;
